import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  id?: string;
  size?: 'md' | 'lg';
  pulse?: boolean;
};
export function CtaButton({
  label,
  id,
  size = 'lg',
  pulse = false
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'min-h-[68px] px-6 py-4 text-[17px] sm:text-xl' : 'min-h-[58px] px-5 py-3.5 text-base sm:text-lg';
  return <a id={id} href={CHECKOUT_URL} className={`group relative flex w-full max-w-xl mx-auto items-center justify-center gap-3 rounded-2xl bg-gold font-extrabold uppercase leading-tight tracking-wide text-ink text-center shadow-[0_10px_0_0_#8f6c1c,0_18px_40px_-10px_rgba(143,108,28,0.6)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-gold-light active:translate-y-[6px] active:shadow-[0_4px_0_0_#8f6c1c] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 ${sizing} ${pulse ? 'animate-pulse-ring' : ''}`} data-id="element-136" data-mp="qir0vgdncusn">
      <span data-id="element-137" data-mp="35yh9e472n85q">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-138" data-mp="35z8weqmlrxke" />
    </a>;
}